// Coalesce invalidations while retaining one more read if a mutation occurs in flight.
// Stream events are hints to refresh; their possibly delayed payload never replaces a newer read.
export function createDispatchRefresh({ load, apply, currentSession }) {
  let running = null, dirty = false;
  return function refresh() {
    dirty = true;
    if (running) return running;
    running = (async () => {
      while (dirty) {
        dirty = false;
        const session = currentSession();
        const snapshot = await load();
        if (!dirty && session && currentSession() === session) apply(snapshot);
      }
    })().finally(() => { running = null; });
    return running;
  };
}

export function applyDispatchSnapshot(snapshot, handlers) {
  if (!snapshot || !Array.isArray(snapshot.units) || !Array.isArray(snapshot.incidents) || !Array.isArray(snapshot.emergencies))
    throw new Error('Incomplete dispatch snapshot; previous state is retained.');
  handlers.units(snapshot.units);
  handlers.history(snapshot.history && typeof snapshot.history === 'object' ? snapshot.history : {});
  handlers.incidents(snapshot.incidents);
  handlers.emergencies(snapshot.emergencies);
}
